(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-offers-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-offers-rotator')) {
    class BfOffersRotator extends HTMLElement {
      connectedCallback() {
        this.images = Array.from(this.querySelectorAll('.bf-offers__img'));
        this.index = 0;
        this.timer = null;
        this.inView = false;
        if (!this.images.length) return;

        this.images[0].classList.add('is-active');
        this.classList.add('is-ready');
        if (this.images.length < 2) return;

        this.interval = Math.max(1000, parseInt(this.dataset.interval, 10) || 2000);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.update = this.update.bind(this);
        this.onUnload = this.onUnload.bind(this);

        this.motionQuery.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        document.addEventListener('shopify:section:unload', this.onUnload);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.inView = entries[entries.length - 1].isIntersecting;
              this.update();
            },
            { rootMargin: '100px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.update();
        }
      }

      disconnectedCallback() {
        this.teardown();
      }

      onUnload(event) {
        if (event.target && event.target.contains(this)) this.teardown();
      }

      teardown() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        document.removeEventListener('shopify:section:unload', this.onUnload);
      }

      update() {
        const canRun = this.inView && !document.hidden && !this.motionQuery.matches;
        if (canRun) this.start();
        else this.stop();
      }

      start() {
        if (this.timer) return;
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        this.images[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.images.length;
        this.images[this.index].classList.add('is-active');
      }
    }

    customElements.define('bf-offers-rotator', BfOffersRotator);
  }

  } catch(e) { console.error(e); }
})();
})();
